import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import { SystemServicesService } from "../system-services.service";

@Component({
  selector: 'app-form-system-services-modal',
  styleUrl: './form-system-services.component.scss',
  templateUrl: './form-system-services.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatBadgeModule,
    MatSlideToggle,
  ],
})
export class FormSystemServicesComponent {

  codeControl = new FormControl('', Validators.required);
  descriptionControl = new FormControl('', Validators.required);
  urlControl = new FormControl('', Validators.required);
  frecuencyControl = new FormControl(null, Validators.required);
  startTimeControl = new FormControl(null)

  //Formulario
  formData = new FormGroup({
    codeControl: this.codeControl,
    descriptionControl: this.descriptionControl,
    urlControl: this.urlControl,
    frecuencyControl: this.frecuencyControl,
    startTimeControl: this.startTimeControl,
  })

  frecuencyList: { fecuency: string; value: string }[] = [
    { fecuency: 'A Demanda', value: 'D'},
    { fecuency: 'Diario', value: 'E'},
  ];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private snackBar: MatSnackBar,  
    private systemServicesService: SystemServicesService,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ){
  }

  ngAfterViewInit():void {
      this.dialogRef.updateSize("90%")
      this.initForm()
  }

  initForm(){
    if(this.data.id){
      Promise.resolve().then(() => {
        this.formData.setValue({
          codeControl: this.data.name,
          descriptionControl: this.data.view,
          urlControl: this.data.url,
          frecuencyControl: this.data.frequency,
          startTimeControl: this.data.startTime,
        })
      });
    }
  }

  resetForm(){
    this.formData.setValue({
      codeControl: '',
      descriptionControl: '',
      urlControl: '',
      frecuencyControl: null,
      startTimeControl: null,
    })
  }

  onSubmit() {
    if(!this.formData.valid){
      return;
    }

    let dataToUpdate = {
      name: this.descriptionControl.value,
      view: this.descriptionControl.value,
      url: this.urlControl.value,
      frequency: this.frecuencyControl.value,
      startTime: this.startTimeControl.value,
    }

    return;
    this.systemServicesService.updateSS(this.data.id, dataToUpdate).subscribe({
      next: (res:any) => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
        this.dialogRef.close("success")
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
      }
    })
  }
}


